import { atom } from 'recoil';
  

export const proposalCount = atom({
    key: 'proposalCount',  
    default: null,  
});